var id = Math.floor(Math.random() * 100);
export default function uniqueId() {
  id += 1;
  return id;
}
//# sourceMappingURL=uniqueId.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/payment/lib/esm/utilities/uniqueId.js
// module id = 604
// module chunks = 0 1